import { makeStyles } from "@saleor/macaw-ui";

const useStyle = makeStyles(
  () => ({
    container: {
      backgroundColor: "#ffffff",
      height: "100%",
      boxShadow: `0px 4px 16px 0px rgba(0, 0, 0, 0.12)`,
      borderRadius: "8px",
      padding: "8px 24px 16px 24px"
    },
    uploadBox: {
      border: `1px dashed #009FB8`,
      padding: "12px",
      height: "95%",
      borderRadius: "4px",
      backgroundColor: "#F2FAFB",
      cursor: "pointer",
      "&:hover": {
        boxShadow: "0px 0px 24px rgba(0, 0, 0, 0.16)"
      }
    },
    title: {
      paddingBottom: "24px",
      color: "#333333"
    },
    uploadTitle: {
      paddingBottom: "8px",
      color: "#222222",
      fontWeight: 400,
      fontSize: "16px"
    },
    uploadTitleBold: {
      paddingBottom: "8px",
      color: "#222222",
      fontWeight: 700
    },
    button: {
      borderRadius: "4px",
      maxWidth: "164px",
      height: "48px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      padding: "16px 22px 16px 22px"
    },
    buttonTitle: {
      color: "white",
      fontSize: "14px",
      paddingLeft: "12px"
    },
    infoIcon: { marginRight: "10.5px" },
    fileName: {
      marginRight: "7px",
      marginLeft: "6px",
      fontSize: "14px !important",
      color: "#333333 !important"
    },
    icon: {
      height: "18px",
      width: "18px",
      cursor: "pointer"
    },
    iconClose: {
      height: "12px",
      width: "12px",
      cursor: "pointer",
      position: "absolute",
      right: "16px"
    },
    uploadResult: {
      padding: "0px 0px 24px 0px",
      borderBottom: "solid 1px #E0E0E0"
    },
    browse: {
      padding: "0px 4px 0px 4px",
      fontWeight: 700,
      fontSize: "14px",
      color: "#009FB8"
    },

    dragTitle: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      color: "#009FB8",
      fontSize: "14px"
    },
    supportTitle: {
      color: "#999999",
      fontSize: "12px"
    },
    note: {
      fontSize: "14px",
      color: "#E41B17"
    },
    notes: {
      fontSize: "14px",
      color: "#E41B17",
      cursor: "pointer"
    }
  }),
  { name: "UploadFile" }
);

export default useStyle;
